import type { Task } from '@/types/task';

const now = Date.now();
const ago = (s: number) => now - s * 1000;

export const INITIAL_TASKS: Task[] = [
  {
    id: 'task_001',
    title: 'Optimiser balises title/meta — ArtWall Studio',
    description: 'Révision complète des balises SEO pour les 48 fiches produits de la boutique Affiches.',
    status: 'in_progress',
    priority: 'high',
    type: 'seo',
    agentId: 'cipher',
    storeId: 'store_affiches',
    createdAt: ago(3600),
    updatedAt: ago(900),
    completedAt: null,
    estimatedTokens: 8000,
    actualTokens: 4200,
    progress: 52,
  },
  {
    id: 'task_002',
    title: 'Créer 12 nouvelles fiches — Paw & Love',
    description: 'Génération de fiches produit pour les nouvelles variantes : totebag, carnet, puzzle.',
    status: 'in_progress',
    priority: 'high',
    type: 'catalogue',
    agentId: 'forge',
    storeId: 'store_animaux',
    createdAt: ago(7200),
    updatedAt: ago(300),
    completedAt: null,
    estimatedTokens: 15000,
    actualTokens: 9800,
    progress: 65,
  },
  {
    id: 'task_003',
    title: 'Campagne emailing Saint-Valentin — Paw & Love',
    description: 'Séquence 3 emails : J-14, J-7, J-1. Ciblage acheteurs précédents + liste newsletter.',
    status: 'waiting_validation',
    priority: 'critical',
    type: 'marketing',
    agentId: 'nova',
    storeId: 'store_animaux',
    createdAt: ago(14400),
    updatedAt: ago(600),
    completedAt: null,
    estimatedTokens: 6000,
    actualTokens: 6100,
    progress: 100,
  },
  {
    id: 'task_004',
    title: 'Analyse chute de trafic — Mots qui Restent',
    description: 'Diagnostic de la baisse de -4.2% : audit backlinks, analyse SERP, rapport concurrent.',
    status: 'in_progress',
    priority: 'high',
    type: 'analytics',
    agentId: 'prism',
    storeId: 'store_citations',
    createdAt: ago(1800),
    updatedAt: ago(120),
    completedAt: null,
    estimatedTokens: 5000,
    actualTokens: 1800,
    progress: 36,
  },
  {
    id: 'task_005',
    title: 'Listing Amazon — Premier Chapitre',
    description: 'Création des listings Amazon UK/DE pour les 5 bestsellers. Backend keywords + A+ content.',
    status: 'waiting_validation',
    priority: 'high',
    type: 'catalogue',
    agentId: 'vector',
    storeId: 'store_famille',
    createdAt: ago(10800),
    updatedAt: ago(1800),
    completedAt: null,
    estimatedTokens: 9000,
    actualTokens: 9200,
    progress: 100,
  },
  {
    id: 'task_006',
    title: 'Posts Instagram × 7 — ArtWall Studio',
    description: 'Rédaction des légendes + hashtags pour la semaine. Format carrousel pour 3 posts.',
    status: 'todo',
    priority: 'medium',
    type: 'content',
    agentId: 'echo',
    storeId: 'store_affiches',
    createdAt: ago(600),
    updatedAt: ago(600),
    completedAt: null,
    estimatedTokens: 3000,
    actualTokens: 0,
    progress: 0,
  },
  {
    id: 'task_007',
    title: 'Audit qualité fiches — Premier Chapitre',
    description: 'Vérification orthographe, cohérence des variantes, conformité images Etsy.',
    status: 'in_progress',
    priority: 'medium',
    type: 'validation',
    agentId: 'argus',
    storeId: 'store_famille',
    createdAt: ago(5400),
    updatedAt: ago(400),
    completedAt: null,
    estimatedTokens: 4000,
    actualTokens: 2100,
    progress: 53,
  },
  {
    id: 'task_008',
    title: 'Réponses avis négatifs — Paw & Love',
    description: '3 avis 2★ reçus cette semaine. Réponses personnalisées + proposition geste commercial.',
    status: 'done',
    priority: 'high',
    type: 'customer_service',
    agentId: 'halo',
    storeId: 'store_animaux',
    createdAt: ago(86400),
    updatedAt: ago(43200),
    completedAt: ago(43200),
    estimatedTokens: 2000,
    actualTokens: 1800,
    progress: 100,
  },
  {
    id: 'task_009',
    title: 'Rapport hebdo performance globale',
    description: 'Consolidation des KPIs des 4 boutiques : CA, marges, tokens, efficacité agents.',
    status: 'todo',
    priority: 'low',
    type: 'analytics',
    agentId: 'prism',
    storeId: null,
    createdAt: ago(300),
    updatedAt: ago(300),
    completedAt: null,
    estimatedTokens: 4500,
    actualTokens: 0,
    progress: 0,
  },
  {
    id: 'task_010',
    title: 'Recherche tendances Q1 2025',
    description: 'Analyse des tendances POD émergentes sur Pinterest Trends + Google Trends.',
    status: 'todo',
    priority: 'low',
    type: 'research',
    agentId: 'nova',
    storeId: null,
    createdAt: ago(120),
    updatedAt: ago(120),
    completedAt: null,
    estimatedTokens: 5000,
    actualTokens: 0,
    progress: 0,
  },
];
